/*
 *
 * file: ParseWordpressResponse.js
 *
 * purpose:
 *   - accepts the response from WP-API
 *   - validates the JSON is complete and a valid response is contained within
 *   - returns a re-formatted (flattened) object to use for rendering via mustache
 *
 */

var ParseWordpressResponse = function(data, postLimit) {

    //let parsedData = {
    var parsedData = {
        posts: []
    };

    if (!data) {
        throw Error("ccWp: Wordpress data must be provided for parsing");
    }

    if (Array.isArray(data) && data.length === 0) {
        throw Error("ccWp: data from the server is empty array; something is wrong");
    }

    var validPostCount = 0;

    for (var postNumber = 0; postNumber < data.length; postNumber++) {
        var post = data[postNumber];
        var rendered = {};

        // Don't include post if it's invalid
        if (
            !post.title || post.title.rendered === "" ||
            !post.excerpt || post.excerpt.rendered === "" ||
            !post.link || post.link === ""
        ) {
            continue;
        }

        rendered.date = post.date;
        rendered.title = post.title.rendered;
        rendered.excerpt = post.excerpt.rendered;
        rendered.link = post.link;
        rendered.mediumImage = '';
        try {
            rendered.mediumImage = post["_embedded"]["wp:featuredmedia"][0]["media_details"]["sizes"]["medium"]["source_url"];
        } 
        catch (err) {}

        parsedData['posts'].push(rendered);

        validPostCount++;
        if (validPostCount >= postLimit) {
            break;
        }
    }

    return parsedData;
};

module.exports = ParseWordpressResponse;
